// <story-scroll> — home story sticky stage (docs/10 FC-2). Progress eases toward the scroll target (lerp 0.14 per 16.7 ms, time-based so 60/120 Hz feel the same);
// only transform/opacity are written; two frames painted at a time. Timeline in vh of pinned scroll:
// desktop p = vh / 167.5 (section 267.5vh), phone p = vh / 207.5 (section 245.25vh; values scaled by 0.7).
// Scroll handling is skipped while the section is more than one viewport off screen.
// 2026-10-23: whisk frames 20% slower (span 30 → 37.5vh); sections grew 7.5vh (phone 5.25vh) so the end hold is unchanged.
const desk = window.matchMedia('(min-width: 1024px)');
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const cl = (x) => Math.min(1, Math.max(0, x));
const io = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
const ios = (x) => -(Math.cos(Math.PI * x) - 1) / 2;
const T = { powder: [4, 79], ch1Out: [88, 110], h2: [110, 122], cta: [120, 132], whiskIn: [112, 122], whisk: [118, 155.5], prog: [110, 124] };

class StoryScroll extends HTMLElement {
  connectedCallback() {
    this.p = null; this.pre = null; this.raf = 0; this.ts = 0; this.near = undefined;
    this.q = (s) => this.querySelector(s); this.qa = (s) => [...this.querySelectorAll(s)];
    this.pow = this.qa('.st-pow .st-f'); this.top = this.qa('.st-top .st-f');
    this.onScroll = () => { if (this.near === false) return; if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.frame(); }); };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(([en]) => { this.near = en.isIntersecting; if (this.near) this.onScroll(); }, { rootMargin: '100% 0px' });
      this.io.observe(this);
    }
    this.frame();
  }
  disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); window.removeEventListener('resize', this.onScroll); this.io?.disconnect(); }
  frame() {
    const r = this.getBoundingClientRect();
    const stage = this.q('.st-stage');
    const vh = stage.getBoundingClientRect().height || window.innerHeight;
    const total = Math.max(1, r.height - vh);
    const tp = cl(-r.top / total);
    const tpre = cl((0.7 * vh - r.top) / (0.7 * vh));
    const now = performance.now();
    if (this.p === null || reduce.matches || Math.abs(tp - this.p) > 0.5) { this.p = tp; this.pre = tpre; this.ts = 0; }
    else {
      const dt = this.ts ? Math.min(64, now - this.ts) : 1000 / 60;
      const k = 1 - Math.pow(1 - 0.14, dt / (1000 / 60));
      this.p += (tp - this.p) * k; this.pre += (tpre - this.pre) * k; this.ts = now;
    }
    const moving = Math.abs(tp - this.p) > 0.0004 || Math.abs(tpre - this.pre) > 0.0004;
    if (!moving) { this.p = tp; this.pre = tpre; this.ts = 0; } else if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.frame(); });

    const K = desk.matches ? 167.5 : 207.5; // vh of pinned scroll that maps to p = 1
    const p = this.p, pre = this.pre, vhpx = vh / 100;
    const seg = ([a, b], v = p) => cl((v - a / K) / ((b - a) / K));
    const seg01 = (a, b, v) => cl((v - a) / (b - a));
    const set = (el, tf, op) => { if (!el) return; if (tf !== null) el.style.transform = tf; if (op !== null) el.style.opacity = op; };
    const lines = (root, k) => { if (!root) return; const ls = root.querySelectorAll('.st-l > span'); const n = ls.length;
      ls.forEach((el, i) => { const a = i / (n + 0.6); const kk = io(cl((k - a) / (1 - (n - 1) / (n + 0.6)))); el.style.transform = `translateY(${(1 - kk) * 105}%)`; el.style.opacity = String(kk); }); };
    const scrub = (els, f) => { if (!els.length) return; const k = f * (els.length - 1); const c = Math.min(els.length - 1, Math.floor(k));
      els.forEach((el, i) => { el.style.opacity = i === c ? '1' : (i === c + 1 ? (k - c).toFixed(3) : '0'); }); };

    // 1 · "Your daily matcha" arrives with the powder frame as the hero leaves; frames scrub; both fade out
    lines(this.q('.st-c2'), seg01(0.15, 0.85, pre));
    const pIn = io(seg01(0.3, 1, pre));
    set(this.q('.st-pow'), `translateY(${(1 - pIn) * 10 * vhpx}px)`, String(pIn));
    scrub(this.pow, seg(T.powder));
    const out = io(seg(T.ch1Out));
    set(this.q('.st-ch2'), `translateY(${-out * 4 * vhpx}px)`, String(1 - out));

    // 2 · "Cha Maker. Whisked in 30 seconds." + CTA; top view settles from vortex to formed
    lines(this.q('.st-c3'), seg(T.h2));
    const cta = io(seg(T.cta));
    set(this.q('.st-cta'), `translateY(${(1 - cta) * 28}px)`, String(cta));
    const ch3 = this.q('.st-ch3'); if (ch3) ch3.style.pointerEvents = cta > 0.6 ? 'auto' : 'none';
    const link = this.q('.st-cta a'); if (link) link.tabIndex = cta > 0.6 ? 0 : -1;
    const tIn = io(seg(T.whiskIn));
    set(this.q('.st-top'), `scale(${1.04 - 0.04 * tIn})`, String(tIn));
    scrub(this.top, ios(seg(T.whisk)));

    const pr = this.q('.st-prog i'); if (pr) pr.style.transform = `scaleY(${p})`;
    const pg = this.q('.st-prog'); if (pg) pg.style.opacity = String(1 - io(seg(T.prog)));
  }
}
if (!customElements.get('story-scroll')) customElements.define('story-scroll', StoryScroll);
